function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.797 2.128C.211 3.715.211 6.268.211 11.375s0 7.66 1.586 9.247c1.587 1.586 4.14 1.586 9.247 1.586s7.66 0 9.247-1.586c1.586-1.587 1.586-4.14 1.586-9.247s0-7.66-1.586-9.247C18.704.542 16.15.542 11.044.542s-7.66 0-9.247 1.586zm11.143 7.08c0 .449.364.813.812.813h.747l-2.18 2.18a.271.271 0 01-.383 0l-1.718-1.718c-.74-.74-1.941-.74-2.681 0l-2.484 2.484a.812.812 0 101.149 1.149l2.484-2.484a.271.271 0 01.383 0l1.718 1.718c.74.74 1.94.74 2.68 0l2.181-2.18v.746a.813.813 0 001.625 0V9.208a.813.813 0 00-.813-.812h-2.708a.813.813 0 00-.812.812z",
  fill: "#fff"
});

function SvgIconInvestPotential(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    fill: "none"
  }, props), _ref);
}

export default SvgIconInvestPotential;